import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet } from 'react-native';

import TabActivityCard from './tab-activity-card';
import useTabActivityCarouselDimensions from './use-tab-activity-carousel-dimensions';
import { TemplateType } from '../../../../enums/template-type';
import { useActivityContext } from '../../../../hooks/use-activity.context';
import KeyboardLegend from '../../../keyboard-legend/keyboard-legend';
import LessonInstructions from '../../../lesson-instructions/lesson-instructions';
import LessonPlayerFrame from '../../../lesson-player-frame/lesson-player-frame';
import VisualHelperOverlay from '../../../visual-helper-overlay/visual-helper-overlay';
import ActivityStepsCarousel from '../../activity-steps-carousel/activity-steps-carousel';

const TabActivity = () => {
  const { t } = useTranslation();
  const [hasMoved, setHasMoved] = useState(false);
  const {
    completeCurrentActivity,
    isCurrentActivityComplete,
    currentActivity,
  } = useActivityContext();

  const carouselDimensions = useTabActivityCarouselDimensions(
    Platform.OS === 'web' ? 340 : 460
  );

  return (
    <>
      <LessonPlayerFrame
        showsVerticalScrollIndicator={false}
        showContinueButton={isCurrentActivityComplete}
      >
        <LessonInstructions
          type="gray"
          style={styles.instructions}
          translation={currentActivity.instructionsTranslation}
        >
          {currentActivity.instructions}
        </LessonInstructions>
        <ActivityStepsCarousel
          steps={currentActivity.steps}
          ItemToRender={TabActivityCard}
          dimensions={carouselDimensions}
          onLastItemReached={completeCurrentActivity}
          onCurrentIndexChanged={(index) => index > 0 && setHasMoved(true)}
        />
      </LessonPlayerFrame>

      <KeyboardLegend
        templateType={TemplateType.TAB}
        forceHide={hasMoved || isCurrentActivityComplete}
        text={t('keyboardLegend.navigate')}
        iconIndicators={['caret-left', 'caret-right']}
      />

      {Platform.OS !== 'web' && <VisualHelperOverlay />}
    </>
  );
};

export default TabActivity;

const styles = StyleSheet.create({
  instructions: {
    paddingVertical: 20,
  },
});
